import { LiabilityImmutableType } from './LiabilitiesWidgets.types';
import { LiabilitiesWidgetTable } from './LiabilitiesWidgetTable';
import React from 'react';

// @ts-expect-error TODO: Fix types once Immutable removed
export const renderWidgets = (liabilities, closeWidget): JSX.Element | null =>
    liabilities.size > 0
        ? liabilities
              .reverse()
              .map((liability: LiabilityImmutableType, marketId: number) => {
                  const multipleLiability = liability.getIn(['multiple', 'liabilities', 'eventId']);
                  const singleLiability = liability.getIn(['single', 'liabilities', 'eventId']);

                  if (multipleLiability === undefined && singleLiability === undefined) {
                      return null;
                  }

                  let single;
                  let multiple;

                  if (singleLiability !== undefined) {
                      single = (
                          <LiabilitiesWidgetTable
                              onCloseRequest={(): void => closeWidget(marketId, 'single')}
                              marketId={marketId}
                              eventId={singleLiability}
                              singlesTableView
                          />
                      );
                  }

                  if (multipleLiability !== undefined) {
                      multiple = (
                          <LiabilitiesWidgetTable
                              onCloseRequest={(): void => closeWidget(marketId, 'multiple')}
                              marketId={marketId}
                              eventId={multipleLiability}
                          />
                      );
                  }

                  return (
                      <div key={marketId}>
                          {single} {multiple}
                      </div>
                  );
              })
              .toArray()
        : null;
